<template>
  <div class="o-toolbar">
    <div class="o-toolbar__left">
      <h2 class="c-heading-2">{{ klas.title }}</h2>
    </div>
    <div class="o-toolbar__right">
      <router-link :to="{ name: 'cataloog', params: { klasId: klas.id }, query: { display: 'raster' } }" v-show="display == 'list'">Rasterweergave</router-link>
      <router-link :to="{ name: 'cataloog', params: { klasId: klas.id } }" v-show="display != 'list'">Lijstweergave</router-link>
    </div>
  </div>
  <form @submit.prevent="onSubmit">
    <div class="o-form">
      <div class="o-input" style="border-bottom: 1px solid rgb(236, 243, 246);">
        <label class="o-input__label"></label>
        <div class="o-input__controls">
          <div class="c-shopping-list">
            <div class="c-shopping-list__row c-shopping-list__row--selected">
              <div class="c-shopping-list__description">
                <div class="c-checkbox">
                  <input type="checkbox" id="all_products" @click="toggleAllProducts" :checked="areAllSelected" />
                  <label for="all_products">Alles (de)selecteren</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-for="category in categories" :key="category.id">
        <component :is="categoryComponent(display)" v-bind="{ category, totalCost: totalCost(category.id) }">
          <template v-for="productNode in categoryProductNodes(category.id)" :key="productNode.value.id">
            <component
              :is="productComponent(display)"
              v-bind="{
                productNode,
                quantity: quantity(productNode),
                quantityEnabled,
                isOrdered: isOrdered(productNode),
                selectedIds: selectedIds(productNode),
                isRequired: isRequired(productNode.value),
              }"
              @add-product="addProduct"
              @remove-product="removeProduct"
              @toggle-product="toggleProduct($event, productNode)"
              @popup-product="modalProduct = $event"
            />
          </template>
        </component>
      </template>

      <OrderTotaal :showSubTotal="false" :showZeroOrderWarning="showZeroOrderWarning" />
    </div>
    <footer class="c-container__footer">
      <div class="o-toolbar">
        <div class="o-toolbar__left">
          <button type="button" class="c-button c-button--default" @click="goBack">Terug</button>
        </div>
        <div class="o-toolbar__right">
          <button type="submit" class="c-button c-button--primary" :class="{ 'c-button--disabled': !isValidOrder }">
            Bestellen
          </button>
        </div>
      </div>
      <p style="float:right;" v-if="submitted && !isValidOrder" class="has-warning">
        Bestelling kan niet doorgaan. Er ontbreken keuzes bij verplichte artikelen
      </p>
    </footer>
  </form>

  <teleport to="#modals">
    <ProductImageModal v-model="modalProduct" />
  </teleport>
</template>

<script>
import catalog from "./Cataloog.vue.js";

export default {
  ...catalog,
};
</script>
